/**
 * Optional list-row fields for the admin Assessment Request grid.
 * Maps common API shapes; returns "" when absent so UI can show "--".
 */

import { getVQALocationFromProvider } from "./addressUtils";
import { getGridArchiveCommentDisplay } from "./gridArchiveCommentDisplay";

export function getAssessmentRequestTypeDisplay(item) {
  const t =
    item?.assessment_type ??
    item?.vqa_assessment_type ??
    item?.assessmentType ??
    item?.document_type;
  if (t == null || t === "") return "";
  return String(t).trim();
}

export function getAssessmentRequestGxpDisplay(item) {
  const v = item?.gxp ?? item?.gxp_label ?? item?.gxp_name ?? item?.GxP;
  if (v == null || v === "") return "";
  return String(v).trim();
}

export function getAssessmentRequestLocationDisplay(item) {
  // TODO: validate correct format for location
  const location = getVQALocationFromProvider(
    { ...item, provider_address1: "" },
    { short: false, abbvState: false }
  );
  if (location == null || location === "") return "";
  return String(location).trim();
}

/**
 * Onsite vs Remote; list payloads may mirror detail `vqa_type` ("onsite" | "remote").
 */
export function getAssessmentRequestOnsiteRemoteDisplay(item) {
  const raw =
    item?.onsite_remote ??
    item?.vqa_type ??
    item?.delivery_mode ??
    item?.assessment_delivery_type;
  if (raw == null || raw === "") return "Remote";
  const s = String(raw).trim().toLowerCase();
  if (s === "onsite" || s === "true" || s === "on-site") return "Onsite";
  if (s === "remote" || s === "false") return "Remote";
  return String(raw).trim();
}

/**
 * Auditor label for assessment list rows when the API includes it.
 * Prefer `vqa_auditor_name` (used across VQA list/detail payloads).
 */
export function getAssessmentRequestAuditorDisplay(item) {
  const name = item?.vqa_auditor_name ?? item?.auditor_name ?? "";
  return String(name).trim();
}

/**
 * Short date display aligned with Innovation Lab AssessmentGrid (`formatShortDate`): M-D-YY.
 * Parses YYYY-MM-DD as local components when possible to avoid timezone shift.
 */
export function formatAssessmentHistoryShortDate(value) {
  if (value == null || value === "") return "";
  try {
    const raw = typeof value === "string" ? value : String(value);
    if (raw === "--") return "--";
    const datePart = raw.split("T")[0];
    const parts = datePart.split("-");
    if (parts.length === 3) {
      const [year, month, day] = parts.map(Number);
      if (year && month && day) {
        return `${month}-${day}-${String(year).slice(-2)}`;
      }
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear().toString().slice(-2);
    return `${month}-${day}-${year}`;
  } catch {
    return "";
  }
}

/** Optional admin-only archive note on assessment request list rows. */
export function getAssessmentRequestArchiveCommentDisplay(item) {
  return getGridArchiveCommentDisplay(item);
}
